<div class="profile-dialog p-4 sm:p-6 font-display bg-white">
  <div class="dialog-header">
    <h2 class="dialog-header__title">Profil</h2>
    <button
      type="button"
      (click)="closeDialog()"
      class="dialog-close"
      aria-label="Tutup"
    >
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>

  <div class="profile-hero" *ngIf="profileData">
    <div class="profile-hero__main">
      <img
        [src]="imageUrl || 'profile.png'"
        alt="Foto profil"
        class="profile-hero__avatar"
      />
      <div class="min-w-0">
        <p class="profile-hero__name">
          {{ profileData.firstName }} {{ profileData.lastName }}
        </p>
        <p class="profile-hero__email">{{ profileData.email ?? "-" }}</p>
      </div>
    </div>
    <div class="profile-hero__meta">
      <span class="employee-badge"
        >ID karyawan {{ profileData.employeeId ?? "-" }}</span
      >
      <button
        type="button"
        (click)="viewProfile(profileData.id)"
        class="btn-view-profile"
      >
        Lihat profile
      </button>
    </div>
  </div>

  <div class="info-grid" *ngIf="profileData">
    <div class="info-item">
      <span class="info-item__label">Team</span>
      <span class="info-item__value">{{
        profileData.team?.name ?? "-"
      }}</span>
    </div>
    <div class="info-item">
      <span class="info-item__label">Role</span>
      <span class="info-item__value">{{
        setRole(profileData.userRoles)
      }}</span>
    </div>
    <div class="info-item">
      <span class="info-item__label">Status kepegawaian</span>
      <span class="info-item__value">{{
        profileData.statusEmployment ?? "-"
      }}</span>
    </div>
    <div class="info-item">
      <span class="info-item__label">Gender</span>
      <span class="info-item__value">{{ profileData.gender ?? "-" }}</span>
    </div>
    <div class="info-item">
      <span class="info-item__label">Tanggal lahir</span>
      <span class="info-item__value">
        <ng-container *ngIf="profileData.birthDate; else noBirthDate">
          {{ profileData.birthDate | date : "d MMMM yyyy" : "+0700" }}
        </ng-container>
        <ng-template #noBirthDate>-</ng-template>
      </span>
    </div>
    <div class="info-item">
      <span class="info-item__label">Tempat lahir</span>
      <span class="info-item__value">{{
        profileData.placeOfBirth ?? "-"
      }}</span>
    </div>
  </div>
</div>
